"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionNavigator = void 0;
var React = require("react");
var NavigatorWidgetBase_1 = require("./NavigatorWidgetBase");
var AccordionNavigator = /** @class */ (function (_super) {
    __extends(AccordionNavigator, _super);
    function AccordionNavigator(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    /**
     * Render the widget
     */
    AccordionNavigator.prototype.render = function () {
        var _this = this;
        var currentItemIndex = _super.prototype.currentIndex.call(this);
        if (currentItemIndex === -1) {
            return (React.createElement(React.Fragment, null,
                this.props.children,
                this.renderNavigation()));
        }
        else {
            return (React.createElement("div", { className: "accordion" },
                React.createElement("div", { className: "card" }, this.props.journey && this.props.journey.navigations.map(function (navigation, index) {
                    var currentBreadcrumbIndex = _this.currentIndex();
                    if (_this.isVisible(navigation) === false) {
                        return null;
                    }
                    return (React.createElement(React.Fragment, { key: navigation.title },
                        React.createElement("div", { className: "card-header ".concat((currentBreadcrumbIndex + 1 === index) ? 'card-footer' : '') },
                            currentBreadcrumbIndex <= index &&
                                React.createElement("span", null, navigation.title),
                            currentBreadcrumbIndex > index &&
                                React.createElement("a", { onClick: _this.handleClick, id: navigation.pages[0], href: "javascript:;" }, navigation.title)),
                        currentBreadcrumbIndex === index &&
                            React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "card-body" },
                                    _this.props.children,
                                    _this.renderNavigation()))));
                }))));
        }
    };
    AccordionNavigator.prototype.renderNavigation = function () {
        return (React.createElement(React.Fragment, null,
            this.renderBackButton(),
            this.renderNextButton()));
    };
    AccordionNavigator.prototype.handleClick = function (e) {
        this.props.engine.navigate(e.target.id, false);
    };
    return AccordionNavigator;
}(NavigatorWidgetBase_1.NavigatorWidgetBase));
exports.AccordionNavigator = AccordionNavigator;
//# sourceMappingURL=AccordionNavigator.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/navigator/AccordionNavigator.js
// module id = 2387
// module chunks = 0